import {Box} from '@dropbox/dig-foundations';
import {Layout} from 'components/DSYS/Layout';

import {RailBadge} from './RailBadge';

/**
 * /workstreams: a rail row that opens its own pane (Audit, Inbox),
 * styled like a group header, with an optional count badge.
 */
export const RailPlaceRow = ({
  label,
  count,
  countLabel,
  selected,
  onSelect,
  bleed,
  touch = false,
}: {
  label: string;
  count: number;
  countLabel: string;
  selected: boolean;
  onSelect: () => void;
  // The rail's horizontal padding, so the row's fill runs edge to edge.
  bleed: {left: number; right: number};
  // Narrow screens' sheet: a finger-sized row.
  touch?: boolean;
}) => (
  <Box style={{marginLeft: -bleed.left, marginRight: -bleed.right}}>
    <Layout.RailTreeRow
      label={label}
      variant="group"
      selected={selected}
      ariaPressed={selected}
      onActivate={onSelect}
      trailing={count > 0 ? <RailBadge count={count} label={countLabel} /> : undefined}
      bleed={bleed}
      touch={touch}
    />
  </Box>
);
